import { gql } from '@apollo/client';

/**
 * GraphQL mutation to logout
 */
export const LOGOUT = gql`
  mutation Logout {
    logout {
      success
      message
    }
  }
`;
